import type { DescriptionsTheme } from './light'
import { commonDark } from '../../_styles/common'
import { self } from './light'

const descriptionsDark: DescriptionsTheme = {
  name: 'Descriptions',
  common: commonDark,
  self
}

export default descriptionsDark
